import { render, staticRenderFns } from "./AppPage.vue?vue&type=template&id=007e553c&scoped=true&"
import script from "./AppPage.vue?vue&type=script&lang=ts&"
export * from "./AppPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007e553c",
  null
  
)

export default component.exports